import { useLazyQuery } from '@apollo/client'
import { useEffect } from 'react'

import { PersistentAlertBannerQuery } from './__generated__/query.graphql'
import { PERSISTENT_ALERT_BANNER_QUERY } from './query'

export const PersistentAlertBanner = () => {
  const [fetchQuery] = useLazyQuery<PersistentAlertBannerQuery>(PERSISTENT_ALERT_BANNER_QUERY)

  useEffect(() => {
    fetchQuery()
  }, [fetchQuery])

  return <div id="persistent-alert-banner"></div>
}
